import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MockDealService {
  env = environment;
  fragment = '/deals';

  constructor(private http: HttpClient) {}

  getDeals():Observable<any> {
    return this.http.get(this.env.rondeivu_api_mock + this.fragment);
  }

  getDeal(id:string):Observable<any> {
    return this.http.get(this.env.rondeivu_api_mock + this.fragment + '/' + id);
  }
}
